(function () {
  const HOVER_DELAY = 140;
  const CLOSE_DELAY = 120;
  const BRAND_OPEN_EVENT = 'sa:brand-mega-opening';
  const INDUSTRY_OPEN_EVENT = 'sa:industry-mega-opening';
  const SOLUTION_OPEN_EVENT = 'sa:solution-nav-opening';
  const finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');

  function activate(menu, tab) {
    const tabs = Array.from(menu.querySelectorAll('[data-sa-brand-dept]'));
    const panels = Array.from(menu.querySelectorAll('[data-sa-brand-panel]'));
    const index = tabs.indexOf(tab);

    if (index < 0) return;

    tabs.forEach((item, itemIndex) => {
      const active = itemIndex === index;
      item.classList.toggle('is-active', active);
      item.setAttribute('aria-selected', active ? 'true' : 'false');
      item.setAttribute('tabindex', active ? '0' : '-1');
    });

    panels.forEach((panel, panelIndex) => {
      const active = panelIndex === index;
      panel.classList.toggle('is-active', active);
      panel.hidden = !active;
      if (active) loadDeferredImages(panel);
    });
  }

  function loadDeferredImages(scope) {
    if (!scope) return;

    scope.querySelectorAll('[data-sa-brand-deferred-image]').forEach((image) => {
      if (image.dataset.src) image.src = image.dataset.src;
      if (image.dataset.srcset) image.srcset = image.dataset.srcset;
      if (image.dataset.sizes) image.sizes = image.dataset.sizes;
      image.removeAttribute('data-sa-brand-deferred-image');
      delete image.dataset.src;
      delete image.dataset.srcset;
      delete image.dataset.sizes;
    });
  }

  function closeMenu(container, trigger, keyboardClosed) {
    if (container) {
      container.classList.remove('is-open');
      container.classList.toggle('sa-brand-mega--keyboard-closed', keyboardClosed === true);
    }
    if (trigger) trigger.setAttribute('aria-expanded', 'false');
  }

  function closeAllBrandMenus(exceptContainer, keyboardClosed) {
    document.querySelectorAll('[data-sa-brand-mega]').forEach((openMenuElement) => {
      const openContainer = openMenuElement.closest('.submenu-container');
      if (!openContainer || openContainer === exceptContainer) return;
      const openTrigger = openContainer.querySelector(':scope > a');
      closeMenu(openContainer, openTrigger, keyboardClosed);
    });
  }

  function openMenu(menu, container, trigger) {
    document.dispatchEvent(new CustomEvent(BRAND_OPEN_EVENT, { detail: { container } }));
    closeAllBrandMenus(container, true);
    if (container) container.classList.add('is-open');
    if (trigger) trigger.setAttribute('aria-expanded', 'true');
    loadDeferredImages(menu.querySelector('[data-sa-brand-panel].is-active'));
  }

  function focusTab(menu, index) {
    const tabs = Array.from(menu.querySelectorAll('[data-sa-brand-dept]'));
    const next = tabs[index];

    if (!next) return;
    activate(menu, next);
    next.focus();
  }

  function initMenu(menu) {
    if (menu.dataset.saBrandMegaReady === 'true') return;
    menu.dataset.saBrandMegaReady = 'true';

    const tabs = Array.from(menu.querySelectorAll('[data-sa-brand-dept]'));
    const container = menu.closest('.submenu-container');
    const trigger = container ? container.querySelector(':scope > a') : null;
    const closeButton = menu.querySelector('[data-sa-brand-mega-close]');
    let hoverTimer = null;
    let closeTimer = null;

    function clearCloseTimer() {
      window.clearTimeout(closeTimer);
    }

    function scheduleClose() {
      clearCloseTimer();
      closeTimer = window.setTimeout(() => closeMenu(container, trigger), CLOSE_DELAY);
    }

    if (trigger) {
      trigger.setAttribute('aria-haspopup', 'true');
      trigger.setAttribute('aria-expanded', 'false');
      trigger.addEventListener('keydown', (event) => {
        if (!['ArrowDown', 'Enter', ' '].includes(event.key)) return;
        event.preventDefault();
        container && container.classList.remove('sa-brand-mega--keyboard-closed');
        openMenu(menu, container, trigger);
        focusTab(menu, 0);
      });
    }

    if (closeButton) {
      closeButton.addEventListener('click', () => {
        closeMenu(container, trigger, true);
        if (trigger) trigger.focus();
      });
    }

    if (container && trigger) {
      container.addEventListener('pointerenter', () => {
        clearCloseTimer();
        container.classList.remove('sa-brand-mega--keyboard-closed');
        openMenu(menu, container, trigger);
      });
      container.addEventListener('pointerleave', () => {
        scheduleClose();
      });
      container.addEventListener('focusin', () => {
        clearCloseTimer();
        if (container.classList.contains('sa-brand-mega--keyboard-closed')) return;
        openMenu(menu, container, trigger);
      });
      container.addEventListener('focusout', () => {
        window.setTimeout(() => {
          if (container.contains(document.activeElement)) return;
          container.classList.remove('sa-brand-mega--keyboard-closed');
          closeMenu(container, trigger);
        }, 0);
      });
    }

    tabs.forEach((tab, index) => {
      tab.addEventListener('pointerenter', () => {
        if (!finePointer.matches) return;
        window.clearTimeout(hoverTimer);
        hoverTimer = window.setTimeout(() => activate(menu, tab), HOVER_DELAY);
      });

      tab.addEventListener('pointerleave', () => {
        window.clearTimeout(hoverTimer);
      });

      tab.addEventListener('focus', () => activate(menu, tab));

      tab.addEventListener('click', (event) => {
        event.preventDefault();
        activate(menu, tab);
      });

      tab.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          event.preventDefault();
          closeMenu(container, trigger, true);
          trigger && trigger.focus();
          return;
        }

        if (event.key === 'Home') {
          event.preventDefault();
          focusTab(menu, 0);
          return;
        }

        if (event.key === 'End') {
          event.preventDefault();
          focusTab(menu, tabs.length - 1);
          return;
        }

        if (event.key === 'ArrowDown' || event.key === 'ArrowRight') {
          event.preventDefault();
          focusTab(menu, (index + 1) % tabs.length);
          return;
        }

        if (event.key === 'ArrowUp' || event.key === 'ArrowLeft') {
          event.preventDefault();
          focusTab(menu, (index - 1 + tabs.length) % tabs.length);
        }
      });
    });
  }

  function initAll() {
    document.querySelectorAll('[data-sa-brand-mega]').forEach(initMenu);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
  document.addEventListener(INDUSTRY_OPEN_EVENT, () => closeAllBrandMenus(null, true));
  document.addEventListener(SOLUTION_OPEN_EVENT, () => closeAllBrandMenus(null, true));
})();
